// removed by extract-text-webpack-plugin
module.exports = {"main-container":"_2jwbwEEZ6e82LFlG-1MXrw","trip-image":"_3kqcKraaxttGgJQ3siWUvq","trip-content":"ZXD68yIZ5asmJEAPl6jVC","trip-name":"_1q3Pe400Jzrhs52HgE6GJ7","trip-prices":"EKCjWLxdGhPXXCsSIWrEi","price-container":"c7e8X_nAVX4O5Bugq6iCJ","discount-price":"nUfmkEXcwBjM6zlK5KzcP","sale-price":"_2Iy9Fxwn-K1oc1Yjp_KNZf","discount-percent-container":"_3SOt4AaXqr8xHux60ESiRo","discount-percent":"_3ois-L5bK79YC3E7u4Oqxs","per-person":"_24mu7OM70V-2pi4GknUdsw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Trip/SharedTrip.scss
// module id = 125
// module chunks = 1 2 9 13 14 24